// extracted by mini-css-extract-plugin
export default {"borderTop":"IssueRefundDialog--borderTop--775482","note":"IssueRefundDialog--note--dca8fd"};